import { BinderAmendment } from "@dune/types";
import { TextArea } from "@dune/ui";
import { useCallback, useEffect, useRef } from "react";

const BinderExclusions = ({
	binderAmendment,
}: {
	binderAmendment: BinderAmendment;
}) => {
	const { generalExclusions, specificExclusions } = binderAmendment;

	const generalTextAreaRef = useRef<HTMLTextAreaElement>(null);
	const specificTextAreaRef = useRef<HTMLTextAreaElement>(null);

	const autoResize = useCallback((textarea: HTMLTextAreaElement) => {
		textarea.style.height = "auto";
		textarea.style.height = `${Math.max(textarea.scrollHeight, 120)}px`;
	}, []);

	useEffect(() => {
		if (generalTextAreaRef.current) {
			autoResize(generalTextAreaRef.current);
		}
		if (specificTextAreaRef.current) {
			autoResize(specificTextAreaRef.current);
		}
	}, [autoResize]);

	return (
		<div className="grid grid-cols-2 gap-4 w-full">
			<div className="flex flex-col gap-4 h-full">
				<h1 className="text-[#144C65] text-2xl font-medium flex-shrink-0">
					Exclusions générales
				</h1>
				<div className="flex-1 flex flex-col">
					<TextArea
						readOnly
						ref={generalTextAreaRef}
						value={generalExclusions || ""}
						className="resize-none p-6"
					/>
				</div>
			</div>
			<div className="flex flex-col gap-4 h-full">
				<h1 className="text-[#144C65] text-2xl font-medium flex-shrink-0">
					Exclusions spécifiques
				</h1>
				<div className="flex-1 flex flex-col">
					<TextArea
						readOnly
						ref={specificTextAreaRef}
						value={specificExclusions || ""}
						className="resize-none p-6"
					/>
				</div>
			</div>
		</div>
	);
};

export default BinderExclusions;
